<app-title-section></app-title-section>

<div class="global-header d-flex flex-column flex-sm-row align-items-start w-100 flex-wrap">
    <app-fourniss-detail-profil [fournisseur]="fournisseur" [isLoading]="isLoading" class="flex-grow-1" style="margin-left: 16px"></app-fourniss-detail-profil>
    <app-fourniss-detail-chiffre-facture-fr [fournisseurId]="fournisseur?.id" class="flex-grow-1"></app-fourniss-detail-chiffre-facture-fr>
    <app-fourniss-detail-chiffre-aff [fournisseurId]="fournisseur?.id" class="flex-grow-1" style="margin-right: 16px"></app-fourniss-detail-chiffre-aff>
    <app-fourniss-detail-contenue class="w-100" style="margin-left: 16px;margin-right: 16px"></app-fourniss-detail-contenue>
</div>

<ng-template #cashAdvanceModal let-modal>
    <div class="modal-header" style="background-color: transparent;">
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0" style="margin: 30px 64px 64px">
        <p class="modal-title titrePop" style="text-align: center;">Avance en espèce</p>
        <p class="titre2" style="text-align: center; margin-top: 12px;">
            Veuillez indiquer le montant pour enregistrer l’avance en espèce.
        </p>
        <form #cashAdvanceForm="ngForm" (ngSubmit)="submitCashAdvance()">
            <div class="form-group">
                <label for="montant" class="form-label">Montant <span class="req">*</span></label>
                <input
                        type="number"
                        class="form-control"
                        id="montant"
                        name="montant"
                        [(ngModel)]="cashAdvance.montant"
                        required
                        min="0"
                        step="0.01"
                        placeholder="Entrez le nom du prix"
                />
            </div>
            <div class="form-group" style="margin: 24px 0">
                <label for="note" class="form-label">Note</label>
                <input
                        class="form-control"
                        id="note"
                        name="note"
                        [(ngModel)]="cashAdvance.note"
                        rows="4"
                        placeholder="Entrez une note"
                >
            </div>
            <div class="d-flex justify-content-center gap-2">
                <button type="submit" class="btn btn-primary" [disabled]="!cashAdvanceForm.valid" style="margin-right: 16px">Confirmer</button>
                <button type="button" class="btn"  style="background: rgba(128, 131, 144, 0.16)" (click)="modal.dismiss('Cancel')">Annuler</button>
            </div>
        </form>
    </div>
</ng-template>
